import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { BankAccount } from 'api/withdrawal'
import { numberFormat } from 'utilities/typeUtility'
import { WithdrawalRequestConstants } from 'constants/withdrawalRequest'

interface WithdrawalConfirmModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  amount: number
  bankAccount: BankAccount | null
  isLoading?: boolean
}

/**
 * 出金申請確認モーダル
 */
const WithdrawalConfirmModal: React.FC<WithdrawalConfirmModalProps> = ({ show, onHide, onConfirm, amount, bankAccount, isLoading = false }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
      <Modal.Body className="px-4">
        <div className="mb-4">
          <p className="mb-3">
            以下の内容で出金申請を行います。
            <br />
            よろしいですか？
          </p>

          <div className="bg-light rounded p-3 mb-3">
            <div className="d-flex justify-content-between">
              <span className="fw-bold">振込額</span>
              <span className="fw-bold font-18" style={{ color: '#102a7e' }}>
                {numberFormat(amount)}円
              </span>
            </div>
          </div>

          {bankAccount && (
            <div className="alert border-0 mb-3" style={{ background: '#fff9e6', color: '#d46b08' }}>
              <small>
                <strong>振込先口座</strong>
                <br />
                {bankAccount.bankName} {bankAccount.branchName}
                <br />
                {bankAccount.accountType} {bankAccount.accountNumber}
                <br />
                {bankAccount.accountName}
              </small>
            </div>
          )}

          <div className="note text-muted">
            <small>※ {WithdrawalRequestConstants.MIN_DAYS_TO_PROCESS}営業日以内に振込処理を行います</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4">
        <Button variant="success" className="flex-fill py-3 me-2" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? '処理中...' : '申請する'}
        </Button>
        <Button variant="outline-primary" className="flex-fill py-3" onClick={onHide}>
          キャンセル
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default WithdrawalConfirmModal
